import { useToast as useToastFromContext } from '../context/ToastContext';

/**
 * Hook to access toast notifications
 * Usage:
 *   const toast = useToast();
 *   toast.success('Success message');
 *   toast.error('Error message');
 *   toast.warning('Warning message');
 *   toast.info('Info message');
 * 
 * @returns {Object} Toast object with success, error, warning, info methods
 */
export const useToast = () => {
  return useToastFromContext();
};

export default useToast;
